import React, { useState } from 'react';

const TimelineChart = ({ data, onDotChange, reference, freeze }) => {
    // Define stage labels
    const stages = ["Planning", "Experimenting", "Stabilization", "Scaling", "Leading"];
    const stageCount = stages.length;
    const step = 100 / (stageCount - 1);
    // Generate ticks: main stage ticks + small ticks in between
    const generateTicks = () => {
        const ticks = [];


        for (let i = 0; i < stageCount; i++) {
            const pos = i * step;
            ticks.push({ position: pos, main: true });

            if (i < stageCount - 1) {
                const mid = pos + step / 2;
                ticks.push({ position: mid, main: false });
            }
        }

        // 🔹 Extra ticks beyond "Leading"
        ticks.push({ position: 100 + step / 2, main: false });
        ticks.push({ position: 100 + step, main: true, label: "" });

        return ticks;
    };



    const ticks = generateTicks();
    const [rows, setRows] = useState(data);

    const handleDrag = (e, rowIndex, dotIndex) => {
        e.preventDefault();
        e.stopPropagation();
        const chart = e.currentTarget.parentElement;
        const chartRect = chart.getBoundingClientRect();

        const onMouseMove = (moveEvent) => {
            let newLeft = ((moveEvent.clientX - chartRect.left) / chartRect.width) * 100;

            // Find nearest tick position
            let nearestTick = ticks.reduce((prev, curr) =>
                Math.abs(curr.position - newLeft) < Math.abs(prev.position - newLeft) ? curr : prev
            );

            newLeft = nearestTick.position;

            // Prevent moving before first dot
            const firstDotPos = rows[rowIndex].dots[0].position;
            const maxLimit = 100 + step; // allow beyond leading
            newLeft = Math.max(firstDotPos, Math.min(maxLimit, newLeft));


            setRows((prev) => {
                const updated = [...prev];
                updated[rowIndex].dots[dotIndex].position = newLeft;
                return updated;
            });
        };

        const onMouseUp = () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);

            // Send updated value to parent
            const newValue = rows[rowIndex].dots[dotIndex].position;
            if (onDotChange) onDotChange(reference, dotIndex, newValue);
        };

        window.addEventListener("mousemove", onMouseMove);
        window.addEventListener("mouseup", onMouseUp);
    };

    const getTargetValue = (position) => {
        if (position >= 100 - step / 2) return "Leading";       // ≥ 87.5
        if (position >= 2.5 * step) return "Scaling";           // ≥ 62.5
        if (position >= 1.5 * step) return "Stabilization";     // ≥ 37.5
        if (position >= 0.5 * step) return "Experimenting";     // ≥ 12.5
        return "Planning";
    };

    return (
        <div className="chart">
            {rows.map((row, rowIndex) => (
                <div style={{ position: 'relative', width: '100%' }}>
                    <div key={rowIndex}>
                        {/* Render ticks */}
                        {ticks.map((t, i) => {

                            // 🔹 Normal ticks
                            return (
                                <div
                                    key={i}
                                    className={`tick ${t.main ? "main-tick" : "small-tick"}`}
                                    style={{
                                        left: `${t.position}%`,
                                        position: "absolute",
                                        height: t.main ? "20px" : "10px",
                                        borderLeft: "2px solid gray",
                                        top: -8,
                                    }}
                                >
                                    {t.main && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "16px",
                                                transform: "translateX(-50%)",
                                                fontSize: "12px",
                                            }}
                                        >
                                            {t.label}
                                        </div>
                                    )}
                                </div>
                            );
                        })}


                        {/* Render dots */}
                        {row.dots.map((dot, dotIndex) => (
                            <div
                                key={dotIndex}
                                className={`dot ${dot.color} ${dot.striped ? "striped" : ""} ${freeze ? "pointer-events-none" : ""
                                    }`}
                                style={{
                                    left: `${dot.position}%`,
                                    position: "absolute",
                                    cursor: dotIndex === 1 ? "grab" : "default",
                                }}
                                onMouseDown={dotIndex === 1 ? (e) => handleDrag(e, rowIndex, dotIndex) : undefined}
                            >
                                {dot.striped && (
                                    <span className="tooltip-text">{getTargetValue(dot.position)}</span>
                                )}
                            </div>
                        ))}

                    </div>
                    <div className="line" style={{ position: "absolute", zIndex: -1, width: '125%' }}></div>
                </div>
            ))}
        </div>
    );
};

export default TimelineChart;
